<template>
	<v-combobox
		ref="widget_field_ref"
		v-model="userCustomOptions"
		:items="customDropdownOptions"
		:placeholder="placeholder"
		:multiple="isMultipleSelectionEnabled"
		:chips="isMultipleSelectionEnabled"
		v-bind="activeFormFieldCommonProps"
		@update:search-input="updateOptionsWithNewChoice"
	>
	</v-combobox>
</template>

<script>
import isString from 'lodash/isString';
import VModelMixin from '@/mixins/VModelMixin';
const HEADER = { header: 'To add an option, type it and press “enter”' };

const getNextId = (options) => options.map((opt) => opt.id).reduce((result, id) => (id < result ? result : id), -99) + 1;
const getOption = (id, text, value) => ({ id, text, value });

export default {
	name: 'DropdownWithCustomOptionsField',
	components: {},
	mixins: [VModelMixin],
	props: {
		dropdownOptions: { type: Array, require: true },
		placeholder: { type: String, require: true },
		isMultipleSelectionEnabled: { type: Boolean, require: true },
		activeFormFieldCommonProps: { type: Object, required: true },
	},
	computed: {
		customDropdownOptions() {
			if (this.newChoice) {
				return [
					HEADER,
					{ id: 0, text: `press enter to create ${this.newChoice}`, disabled: true },
					...this.dropdownOptions.filter((x) => x?.text.includes(this.newChoice)),
					...this.userCustomOptionValues.filter((x) => x?.text.includes(this.newChoice)),
				];
			}
			return [HEADER, ...this.dropdownOptions, ...this.userCustomOptionValues];
		},
	},
	methods: {
		focus() {
			this.$refs.input?.focus?.();
		},
		updateOptionsWithNewChoice(input) {
			const found = this.customDropdownOptions.find((x) => x?.text === input);
			if (!found) {
				this.newChoice = input;
			}
		},
	},
	watch: {
		value: {
			handler(newValue) {
				if (newValue) {
					this.userCustomOptions = this.customDropdownOptions.find((option) => option.value === newValue);
				}
			},
			immediate: true,
		},
		userCustomOptions: {
			handler(newValue) {
				this.newChoice = '';
				if (this.isMultipleSelectionEnabled) {
					if (Array.isArray(newValue)) {
						if (newValue.length === 0) {
							this.userCustomOptionValues = [];
							this.localValue = '';
						} else {
							const lastUpdated = newValue[newValue.length - 1];
							if (isString(lastUpdated)) {
								this.userCustomOptionValues.push(getOption(getNextId(this.dropdownOptions), lastUpdated, lastUpdated));
							}
							this.userCustomOptionValues = this.userCustomOptionValues.filter((x) => newValue.includes(x.text));
							this.localValue = newValue.map((x, index) => (isString(x) ? { id: index + 1, text: x, value: x } : { ...x, id: index + 1 }));
						}
					}
				} else {
					if (isString(newValue)) {
						this.userCustomOptionValues = [...this.userCustomOptionValues, getOption(getNextId(this.dropdownOptions), newValue, newValue)];
						this.localValue = newValue;
					} else {
						this.userCustomOptionValues = [...this.userCustomOptionValues];
						this.localValue = newValue?.text;
					}
				}
			},
		},
	},
	data() {
		return {
			userCustomOptions: undefined,
			userCustomOptionValues: [],
			newChoice: '',
		};
	},
};
</script>

<style scoped lang="scss"></style>
